import { PRIORITY } from '../../lib/statusConfig';

/** @param {{priority: keyof typeof PRIORITY}} props */
export default function PriorityChip({ priority }) {
  const cfg = PRIORITY[priority];
  if (!cfg) return <span className="text-ink-faint text-xs">—</span>;
  return (
    <span className={`inline-flex items-center gap-1.5 text-xs font-semibold ${cfg.text}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${cfg.dot}`} />
      {cfg.label}
    </span>
  );
}
